<ckeditor
  [disabled]="disabled"
  [hidden]="!Editor || !config"
  [(ngModel)]="value"
  [config]="config"
  [editor]="Editor"
  (change)="changed($event)"
  (ready)="onEditorReady($event)"
>
</ckeditor>
